module.exports = __webpack_public_path__ + "img/proposed-subjects-coachmark-modal.35ab568c.png";